import React from 'react';
import { Link } from 'react-router-dom';
import { waLink } from './analytics';
import { Search, TrendingUp, Target, Award, Clock, Shield, ChevronRight, CheckCircle2, BarChart3, Zap } from 'lucide-react';
import './App.css';
import './SEO.css';

function SEO() {
  const seoPackages = [
    {
      name: 'SEO Starter',
      price: '599.000',
      period: 'bulan',
      description: 'Paket dasar untuk memulai optimasi SEO dengan fokus pada fondasi teknis dan perbaikan on-page pada halaman prioritas.',
      features: [
        'Audit awal (ringkas) dan prioritas perbaikan',
        'Riset kata kunci dasar (core keywords)',
        'Optimasi on-page untuk halaman prioritas',
        'Rekomendasi perbaikan konten',
        'Laporan bulanan ringkas'
      ],
      popular: false,
      color: '#16a34a',
    },
    {
      name: 'SEO Growth',
      price: '999.000',
      period: 'bulan',
      description: 'Paket pengembangan untuk meningkatkan performa SEO secara lebih konsisten melalui optimasi halaman yang lebih luas dan perbaikan konten berkelanjutan.',
      features: [
        'Audit teknis dan on-page lebih detail',
        'Riset kata kunci terarah (cluster/topik)',
        'Optimasi lebih banyak halaman',
        'Rekomendasi konten lanjutan',
        'Monitoring performa kata kunci',
        'Laporan bulanan + rekomendasi aksi'
      ],
      popular: true,
      color: '#2563eb',
    },
    {
      name: 'SEO Authority',
      price: '1.499.000',
      period: 'bulan',
      description: 'Paket untuk memperkuat otoritas dan daya saing SEO dengan pendekatan yang lebih komprehensif, mencakup strategi konten, optimasi teknis, dan perbaikan berulang berbasis data.',
      features: [
        'Audit teknis menyeluruh',
        'Riset kata kunci mendalam (topical map)',
        'Optimasi on-page komprehensif',
        'Strategi konten lengkap',
        'Monitoring dan evaluasi performa',
        'Laporan bulanan detail + rencana kerja'
      ],
      popular: false,
      color: '#dc2626',
    },
  ];

  return (
    <div className="app">
      <main>
        <section className="hero seo-hero">
        <div className="hero__inner">
          <div className="hero__content">
            <div className="hero__badge">
              <Search className="hero__badge-icon" size={20} />
              <span className="hero__badge-text">SEO Optimization Services</span>
            </div>
            <h1 className="hero__title">SEO Optimization Services</h1>
            <p className="hero__subtitle">
              Optimasi mesin pencari berbasis strategi teknis dan konten untuk meningkatkan visibilitas website serta mendatangkan traffic organik berkualitas.
            </p>
            <div className="hero__stats">
              <div className="hero__stat">
                <div className="hero__stat-number">3+</div>
                <div className="hero__stat-label">Proyek SEO</div>
              </div>
              <div className="hero__stat">
                <div className="hero__stat-number">100%</div>
                <div className="hero__stat-label">Klien Puas</div>
              </div>
              <div className="hero__stat">
                <div className="hero__stat-number">24/7</div>
                <div className="hero__stat-label">Support</div>
              </div>
            </div>
            <div className="hero__actions">
              <Link to="/consultation" className="btn btn-primary btn-large">
                <span>Start SEO Optimization</span>
                <ChevronRight size={20} />
              </Link>
              <a href={waLink('Halo, saya ingin konsultasi SEO. Mohon info lebih lanjut.')} target="_blank" rel="noopener noreferrer" className="btn btn-secondary btn-large">
                <span>Free SEO Audit</span>
                <Search size={20} />
              </a>
            </div>
          </div>
          <div className="hero__visual">
            <div className="hero__graphics">
              <div className="floating-card">
                <BarChart3 className="floating-card__icon" size={32} />
                <div className="floating-card__title">Analytics</div>
                <div className="floating-card__value">Growing</div>
              </div>
              <div className="floating-card">
                <Target className="floating-card__icon" size={32} />
                <div className="floating-card__title">Keywords</div>
                <div className="floating-card__value">Optimized</div>
              </div>
              <div className="floating-card">
                <TrendingUp className="floating-card__icon" size={32} />
                <div className="floating-card__title">Results</div>
                <div className="floating-card__value">Focused</div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="seo-intro">
        <div className="seo-intro__inner">
          <div className="seo-intro__content">
            <h2 className="section-title">Mengapa SEO Penting untuk Bisnis Anda?</h2>
            <p className="seo-intro__text">
              Search Engine Optimization (SEO) adalah investasi jangka panjang untuk meningkatkan visibility online bisnis Anda. 
              Dengan semakin banyak bisnis yang beralih ke digital, memiliki website yang mudah ditemukan di mesin pencari menjadi kunci sukses.
            </p>
            <div className="seo-stats">
              <div className="seo-stat">
                <div className="seo-stat__number">68%</div>
                <div className="seo-stat__label">Pengalaman online dimulai dari search</div>
              </div>
              <div className="seo-stat">
                <div className="seo-stat__number">53%</div>
                <div className="seo-stat__label">Traffic website berasal dari organic search</div>
              </div>
              <div className="seo-stat">
                <div className="seo-stat__number">3x</div>
                <div className="seo-stat__label">Lebih banyak leads dari SEO vs paid ads</div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="seo-pricing">
        <div className="seo-pricing__container">
          <header className="seo-pricing__header">
            <div className="seo-pricing__badge">
              <Award className="seo-pricing__badge-icon" size={20} />
              <span>Investasi Cerdas untuk Pertumbuhan</span>
            </div>
            <h2 className="seo-pricing__title">Paket Harga SEO</h2>
            <p className="seo-pricing__subtitle">Solusi SEO profesional dengan harga transparan dan hasil terukur</p>
            <div className="seo-pricing__trust">
              <div className="trust-item">
                <CheckCircle2 className="trust-item__icon" size={16} />
                <span>Garansi Ranking</span>
              </div>
              <div className="trust-item">
                <Shield className="trust-item__icon" size={16} />
                <span>Money Back Guarantee</span>
              </div>
              <div className="trust-item">
                <Clock className="trust-item__icon" size={16} />
                <span>Support 24/7</span>
              </div>
            </div>
          </header>
          <div className="seo-pricing__grid">
            {seoPackages.map((pkg, index) => (
              <div key={pkg.name} className={`seo-pricing-card ${pkg.popular ? 'featured' : ''}`} style={{ '--accent-color': pkg.color }}>
                {pkg.popular && (
                  <div className="seo-pricing-card__badge">
                    <span className="seo-pricing-card__badge-text">Recommended</span>
                  </div>
                )}
                
                <div className="seo-pricing-card__header">
                  <div className="seo-pricing-card__icon-wrapper">
                    {pkg.name === 'SEO Starter' && <Search className="seo-pricing-card__icon" size={32} />}
                    {pkg.name === 'SEO Growth' && <TrendingUp className="seo-pricing-card__icon" size={32} />}
                    {pkg.name === 'SEO Authority' && <Award className="seo-pricing-card__icon" size={32} />}
                  </div>
                  <h3 className="seo-pricing-card__name">{pkg.name}</h3>
                  <div className="seo-pricing-card__price">
                    <span className="seo-pricing-card__currency">Rp</span>
                    <span className="seo-pricing-card__amount">{pkg.price}</span>
                    <span className="seo-pricing-card__period">/{pkg.period}</span>
                  </div>
                  <p className="seo-pricing-card__description">{pkg.description}</p>
                  {pkg.popular && (
                    <div className="seo-pricing-card__value">
                      <span className="seo-pricing-card__value-text">Best Value</span>
                      <div className="seo-pricing-card__value-stars">
                        <span>⭐⭐⭐⭐⭐</span>
                      </div>
                    </div>
                  )}
                </div>

                <div className="seo-pricing-card__features">
                  <ul className="seo-pricing-card__features-list">
                    {pkg.features.map((feature, featureIndex) => (
                      <li key={featureIndex} className="seo-pricing-card__feature">
                        <svg className="seo-pricing-card__check" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                          <path d="M20 6L9 17l-5-5"/>
                        </svg>
                        <span>{feature}</span>
                      </li>
                    ))}
                  </ul>
                </div>

                <div className="seo-pricing-card__action">
                  <button
                    className="seo-pricing-card__cta"
                    onClick={() => {
                      const message = `Halo, saya ingin memilih paket SEO: ${pkg.name}. Mohon info lebih lanjut.`;
                      window.open(waLink(message), '_blank', 'noopener,noreferrer');
                    }}
                  >
                    Konsultasi Sekarang
                  </button>
                </div>
              </div>
            ))}
          </div>
          
          <div className="seo-pricing__note">
            <p>Hasil SEO dipengaruhi oleh kompetitor, usia domain, dan kualitas konten.</p>
          </div>
        </div>
      </section>

      <section className="seo-process">
        <div className="seo-process__inner">
          <div className="section-header">
            <div className="section-badge">Proses Kami</div>
            <h2 className="section-title">Metodologi SEO Sistematis</h2>
            <p className="section-subtitle">Pendekatan terstruktur untuk hasil optimal</p>
          </div>
          <div className="seo-process__timeline">
            <div className="seo-process__step">
              <div className="seo-process__icon-wrapper">
                <Search className="seo-process__icon" size={24} />
                <div className="seo-process__number">1</div>
              </div>
              <div className="seo-process__content">
                <h3>Audit & Analysis</h3>
                <p>Analisis website, kompetitor, dan peluang pasar untuk optimasi yang tepat.</p>
                <div className="seo-process__deliverables">
                  <span>Technical Audit</span>
                  <span>Competitor Analysis</span>
                  <span>Keyword Research</span>
                </div>
              </div>
            </div>
            <div className="seo-process__step">
              <div className="seo-process__icon-wrapper">
                <Target className="seo-process__icon" size={24} />
                <div className="seo-process__number">2</div>
              </div>
              <div className="seo-process__content">
                <h3>Strategy Planning</h3>
                <p>Merancang strategi SEO yang disesuaikan dengan tujuan bisnis Anda.</p>
                <div className="seo-process__deliverables">
                  <span>SEO Roadmap</span>
                  <span>Content Strategy</span>
                  <span>Link Building Plan</span>
                </div>
              </div>
            </div>
            <div className="seo-process__step">
              <div className="seo-process__icon-wrapper">
                <Zap className="seo-process__icon" size={24} />
                <div className="seo-process__number">3</div>
              </div>
              <div className="seo-process__content">
                <h3>Implementation</h3>
                <p>Eksekusi optimasi on-page, off-page, dan technical SEO dengan best practices.</p>
                <div className="seo-process__deliverables">
                  <span>On-Page Optimization</span>
                  <span>Content Creation</span>
                  <span>Quality Backlinks</span>
                </div>
              </div>
            </div>
            <div className="seo-process__step">
              <div className="seo-process__icon-wrapper">
                <TrendingUp className="seo-process__icon" size={24} />
                <div className="seo-process__number">4</div>
              </div>
              <div className="seo-process__content">
                <h3>Monitoring & Optimization</h3>
                <p>Tracking performa dan optimasi berkelanjutan untuk hasil maksimal.</p>
                <div className="seo-process__deliverables">
                  <span>Performance Reports</span>
                  <span>KPI Tracking</span>
                  <span>Continuous Optimization</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="seo-guarantee">
        <div className="seo-guarantee__inner">
          <div className="section-header">
            <div className="section-badge">Komitmen Kami</div>
            <h2 className="section-title">Fokus pada Kualitas & Hasil</h2>
            <p className="section-subtitle">Layanan SEO terbaik dengan pendekatan transparan dan hasil terukur</p>
          </div>
          <div className="seo-guarantee__items">
            <div className="seo-guarantee__item">
              <div className="seo-guarantee__icon-wrapper">
                <Target className="seo-guarantee__icon" size={32} />
              </div>
              <div className="seo-guarantee__content">
                <h3>Strategi Targeted</h3>
                <p>Pendekatan SEO yang disesuaikan dengan tujuan bisnis Anda untuk hasil relevan.</p>
                <div className="seo-guarantee__metrics">
                  <span>Custom Strategy</span>
                  <span>Business Focused</span>
                </div>
              </div>
            </div>
            <div className="seo-guarantee__item">
              <div className="seo-guarantee__icon-wrapper">
                <TrendingUp className="seo-guarantee__icon" size={32} />
              </div>
              <div className="seo-guarantee__content">
                <h3>Improvement Berkelanjutan</h3>
                <p>Optimasi SEO berkelanjutan untuk meningkatkan visibility dan traffic organik.</p>
                <div className="seo-guarantee__metrics">
                  <span>Monthly Reports</span>
                  <span>Continuous Optimization</span>
                </div>
              </div>
            </div>
            <div className="seo-guarantee__item">
              <div className="seo-guarantee__icon-wrapper">
                <Shield className="seo-guarantee__icon" size={32} />
              </div>
              <div className="seo-guarantee__content">
                <h3>Support Penuh</h3>
                <p>Dukungan penuh dan konsultasi berkelanjutan untuk strategi SEO optimal.</p>
                <div className="seo-guarantee__metrics">
                  <span>Full Support</span>
                  <span>Transparency</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="seo-cta">
        <div className="seo-cta__inner">
          <div className="seo-cta__content">
            <div className="seo-cta__badge">
              <Zap className="seo-cta__badge-icon" size={20} />
              <span>Mulai Sekarang</span>
            </div>
            <h2 className="seo-cta__title">Siap Memulai Optimasi SEO?</h2>
            <p className="seo-cta__subtitle">
              Konsultasi gratis untuk analisis SEO dasar dan rekomendasi strategi yang tepat untuk bisnis Anda.
            </p>
            <div className="seo-cta__stats">
              <div className="seo-cta__stat">
                <div className="seo-cta__stat-number">3+</div>
                <div className="seo-cta__stat-label">Proyek Selesai</div>
              </div>
              <div className="seo-cta__stat">
                <div className="seo-cta__stat-number">100%</div>
                <div className="seo-cta__stat-label">Klien Puas</div>
              </div>
              <div className="seo-cta__stat">
                <div className="seo-cta__stat-number">24/7</div>
                <div className="seo-cta__stat-label">Support</div>
              </div>
            </div>
            <div className="seo-cta__buttons">
              <Link to="/consultation" className="btn btn-primary btn-large btn-glow">
                <span>Konsultasi SEO Gratis</span>
                <ChevronRight size={20} />
              </Link>
              <a href={waLink('Halo, saya ingin konsultasi SEO. Mohon info lebih lanjut.')} target="_blank" rel="noopener noreferrer" className="btn btn-secondary btn-large">
                <span>Chat WhatsApp</span>
                <Search size={20} />
              </a>
            </div>
            <div className="seo-cta__trust">
              <div className="trust-item">
                <CheckCircle2 className="trust-item__icon" size={16} />
                <span>Free Consultation</span>
              </div>
              <div className="trust-item">
                <Clock className="trust-item__icon" size={16} />
                <span>Quick Response</span>
              </div>
              <div className="trust-item">
                <Award className="trust-item__icon" size={16} />
                <span>Professional Service</span>
              </div>
            </div>
          </div>
        </div>
      </section>
      </main>
    </div>
  );
}

export default SEO;
